/**
 * @author NikolaV
 */

import { action, makeObservable, observable } from 'mobx';


export class TableStateStore {
    @observable loading = true;
    @observable first = 0;
    @observable pageSize = 20;
    @observable totalRecords = 0;
    @observable sortColumn = 'name';
    @observable sortDirection = 'asc';

    @action
    updateFromPrimeTableEvent = (evt: { first: number, page: number, pageCount: number, rows: number}) => {
        if (evt.hasOwnProperty('first')) {
            this.first = evt.first;
        }

        if (evt.hasOwnProperty('rows')) {
            this.pageSize = evt.rows;
        }
    }

    constructor() {
        makeObservable(this);
    }

    resetPaging() {
        this.first = 0;
        this.totalRecords = 0;
    }
}
